"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralVariantTypes = exports.ReferralSubTypes = exports.ReservationTypes = void 0;
var ReservationTypes;
(function (ReservationTypes) {
    ReservationTypes["RESERVE"] = "reserve";
    ReservationTypes["DIAL"] = "dial";
})(ReservationTypes = exports.ReservationTypes || (exports.ReservationTypes = {}));
var ReferralSubTypes;
(function (ReferralSubTypes) {
    ReferralSubTypes["LABORATORY"] = "laboratory";
    ReferralSubTypes["IMAGING"] = "imaging";
    ReferralSubTypes["ENDOSCOPY"] = "endoscopy";
    ReferralSubTypes["FYSIO"] = "physiotherapy";
    ReferralSubTypes["FYSIO_OLD"] = "fysio";
    ReferralSubTypes["CONSULTATION"] = "consultation";
    ReferralSubTypes["DENTAL_CHECKUP"] = "dental_checkup";
    ReferralSubTypes["AD_SV3SHM"] = "ad_sv3shm";
    ReferralSubTypes["DENTAL_RECALL_DENTIST"] = "dental_recall_dentist";
    ReferralSubTypes["DENTAL_RECALL_HYGIENIST"] = "dental_recall_hygienist";
})(ReferralSubTypes = exports.ReferralSubTypes || (exports.ReferralSubTypes = {}));
var ReferralVariantTypes;
(function (ReferralVariantTypes) {
    ReferralVariantTypes["NEW"] = "referral-new";
    ReferralVariantTypes["EXPIRES"] = "referral-expires";
    ReferralVariantTypes["DEFAULT"] = "referral-default";
})(ReferralVariantTypes = exports.ReferralVariantTypes || (exports.ReferralVariantTypes = {}));
